const defaultTheme = {
  ltr: 'ltr',
  rtl: 'rtl',
  placeholder: 'editor-placeholder',
  paragraph: 'mb-4 last:mb-0',
  list: {
    nested: {
      listitem: 'list-none ps-0',
    },
    ol: 'list-decimal mb-4 last:mb-0 ml-3.5 ps-0',
    ul: 'list-disc mb-4 last:mb-0 ml-3.5 ps-0',
    listitem: 'ml-3.5 pl-2 ps-1',
  },
  image: 'editor-image',
  link: 'editor-link',
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
  },
  code: 'code',
};

export default defaultTheme;
